<main class="pl-10 pr-6 lg:pr-12 py-4 pb-20">
  <ng-content></ng-content>
</main>
